import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunkAPIType } from "../../app/appTypes";
import { getWithAuth } from "../../http";

export type BackgroundProcessObjectType = 'URS_OFFER' | 'DOCUMENT' | 'IMPORTED_DOCUMENT';

export interface BackgroundProcessSummaryDto {
    id: string;
    processNumber: number;
    operationType: string;
    status: string;
    displayName: string;
    companyId: number;
    startedAt: Date;
    initiatedByUserId: string;
    completedAt: Date;
    relatedObjectId: string;
    relatedObjectType: string;
    progressPercent: number;
    progressCurrent: number;
    progressTotal: number;
}

export interface MyBackgroundProcessesSummaryDto {
    activeCount: number;
    completedTodayCount: number;
    active: BackgroundProcessSummaryDto[];
    recentCompleted: BackgroundProcessSummaryDto[];
}

export const loadAllBackgroundProcessSummaryForObject = createAsyncThunk<
    BackgroundProcessSummaryDto[], { objectType: string; objectId: string }, AppThunkAPIType>(
        "background-processes/get-all-for-object",
        async ({ objectType, objectId }, { dispatch, rejectWithValue }) => {
            const result = await dispatch(
                getWithAuth({ url: `api/background-processes/get-all-for-object/${objectType}/${objectId}` })
            );

            const { payload } = result;

            if (getWithAuth.fulfilled.match(result)) {
                return payload as BackgroundProcessSummaryDto[] || [];
            } else {
                return rejectWithValue(payload ?? { kind: "unknown" });
            }
        }
    );

export const loadBackgroundProcessSummaryForObject = createAsyncThunk<
    BackgroundProcessSummaryDto, { objectType: string; objectId: string }, AppThunkAPIType>(
        "public-access-private-token-load",
        async ({ objectType, objectId }, { dispatch, rejectWithValue }) => {
            const result = await dispatch(
                getWithAuth({ url: `api/background-processes/get-for-object/${objectType}/${objectId}` })
            );

            const { payload } = result;

            if (getWithAuth.fulfilled.match(result)) {
                return payload as BackgroundProcessSummaryDto;
            } else {
                return rejectWithValue(payload ?? { kind: "unknown" });
            }
        }
    );

export const loadBackgroundProcessSummaryById = createAsyncThunk<
    BackgroundProcessSummaryDto, string, AppThunkAPIType>(
        "background-processes/get-by-id",
        async (processId, { dispatch, rejectWithValue }) => {
            const result = await dispatch(
                getWithAuth({ url: `api/background-processes/get/${processId}` })
            );

            const { payload } = result;

            if (getWithAuth.fulfilled.match(result)) {
                return payload as BackgroundProcessSummaryDto;
            } else {
                return rejectWithValue(payload ?? { kind: "unknown" });
            }
        }
    );

export const loadMyBackgroundProcessesSummary = createAsyncThunk<
    MyBackgroundProcessesSummaryDto,
    void,
    AppThunkAPIType
>(
    "background-processes/get-my-processes-summary",
    async (_, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            getWithAuth({ url: "api/background-processes/my-processes/summary" })
        );

        const { payload } = result;

        if (getWithAuth.fulfilled.match(result)) {
            return payload as MyBackgroundProcessesSummaryDto;
        } else {
            return rejectWithValue(payload ?? { kind: "unknown" });
        }
    }
);
